import { type PropsWithChildren, createContext, useContext, useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { IChatbotFullData } from 'entities/Chatbot/api/chatbotTypes'
import { UnifiedAgentStore } from '../store/unifiedAgentStore'

const UnifiedAgentContext = createContext<UnifiedAgentStore | null>(null)

export const useUnifiedAgentContext = () => {
  const context = useContext(UnifiedAgentContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with UnifiedAgentProvider')

  return context
}

type IUnifiedAgentProviderProps = PropsWithChildren<{
  agentId: number | null
  initialData?: IChatbotFullData
}>

export const UnifiedAgentProvider = ({
  agentId,
  initialData,
  children,
}: IUnifiedAgentProviderProps) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new UnifiedAgentStore(agentId, entities, initialData))

  useEffect(() => store.dispose, [])

  return <UnifiedAgentContext.Provider value={store}>{children}</UnifiedAgentContext.Provider>
}
